export const SOCIAL_NETWORKS = [
	{ icon: "fa-github-alt", link: "https://github.com/Mia-Salazar", aria: "alt.github" },
	{ icon: "fa-codepen", link: "https://codepen.io/MiaSalazar", aria: "alt.codepen" },
	{ icon: "fa-linkedin-in", link: "https://www.linkedin.com/in/miasalazar/", aria: "alt.linkedin" },
	{ icon: "fa-medium-m", link: "https://marasalazar.medium.com/", aria: "alt.medium" },
	{ icon: "fa-twitter", link: "https://twitter.com/miadeveloper", aria: "alt.twitter" },
];
